export enum UserAccountProvider {
  Google = 'GoogleSignIn',
  Facebook = 'Facebook'
}

export interface UserAccount {
  provider: UserAccountProvider;
  avatarURL: string;
}

export interface User {
  username: string;
  firstName: string;
  lastName: string;
  email: string;
}

export interface AuthenticatedUser extends User {
  groups: UserGroup[];
  accounts: UserAccount[];
}

export interface RegistrationRequest {
  name: string;
  email: string;
  password: string;
  marketingConsent: boolean;
}

export enum UserGroup {
  Customer = 'Customer',
  Landlord = 'Landlord'
}